export const SET_LATLNG = "SET_LATLNG";
export const SET_ZOOM = "SET_ZOOM";
export const GET_BRANCHES = "GET_BRANCHES";